import { core } from 'etl/core';
import { homeRoutes } from 'etl/types';
import { Navigate } from 'react-router';

export interface ProtectedRouteProps {
  children: React.ReactElement;
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { children } = props;

  const { isAuthenticated } = core.useAuthSelectors();

  if (!isAuthenticated) {
    return <Navigate to={homeRoutes.home.path} />
  }

  return children;
};
